module.exports = "/_next/static/images/Hero@2x-863ce3cfc40983a3aa3ce74ef8499445.webp";